<template>
  <div class="index">
    <div class="layout-item">
      <div class="title">数据概况</div>
      <div class="select-item df mb-20">
        <div class="df">
          <div>
            快速查看：
            <el-radio-group v-model="radioValue" text-color="#FF3B39">
              <!-- label文本不能乱改 -->
              <el-radio-button label="今日"></el-radio-button>
              <el-radio-button label="昨日"></el-radio-button>
              <el-radio-button label="最近7日"></el-radio-button>
              <el-radio-button label="最近30日"></el-radio-button>
            </el-radio-group>
          </div>
          <div class="ml-20">
            选择时间：
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              start-placeholder="开始时间"
              range-separator="~"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="{
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              }"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="data-table df justify-between">
          <div 
            v-for="(item, index) in dataObj" 
            :key="index"
            :class="['data-item', 'mt-20', 'mb-20', { 'csp': item.route }]"
            @click="item.route && handleItemClick(item)"
          >
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              :content="item.tips"
            >
              <div slot="reference" class="df fdc align-start popover-dom">
                <div class="df align-center data-item__name-wrapper">
                  <div class="data-item__name">{{ item.name }}</div>
                  <img
                    src="@/assets/images/tip_icon.png"
                    alt=""
                    class="tip-icon"
                  />
                </div>
                <div class="data-item__data mt-10">{{ item.value }}</div>
              </div>
            </el-popover>
          </div>
      </div>
    </div>
    <!-- <div class="layout-item">
      <div class="title">最近7日数据</div>
      <div class="data-chart">
        <ve-line
          class="order-vchart"
          scale="true"
          :data="sellChartData"
          :colors="chartColors"
          :height="chartHeight"
        ></ve-line>
      </div>
    </div> -->
  </div>
</template>

<script>
  import {
    formatDate,
    formatYesterday,
    getLastSevenDate,
    getLastThirtyDate,
  } from "@/assets/lib/js/date.js";
  export default {
    name: "index",
    data() {
      return {
        radioValue: "今日",
        dateValue: [formatDate(new Date()), formatDate(new Date())],
        timeValue: [formatDate(new Date()), formatDate(new Date())],
        isSyncingQuickRange: false,
        dataObj: [
          {
            name: "分享次数",
            tips: "店铺首页、优惠券、产品链接被分享次数",
            value: 0,
            key: "share_num"
          },
          {
            name: "首页浏览次数",
            tips: "店铺首页链接浏览的次数",
            value: 0,
            key: "index_pv_num"
          },
          {
            name: "优惠券浏览次数",
            tips: "店铺优惠券链接浏览的次数",
            value: 0,
            key: "coupons_pv_num",
            route: "statistics/coupons-pv-view",
            routeTitle: "优惠券浏览数据"
          },
          {
            name: "产品浏览次数",
            tips: "店铺产品链接浏览的次数",
            value: 0,
            key: "product_pv_num",
            route: "statistics/product-pv-view",
            routeTitle: "产品浏览数据"
          },
          {
            name: "领券张数",
            tips: "用户领取店铺优惠券的数量",
            value: 0,
            key: "coupons_num",
            route: "statistics/coupons-view",
            routeTitle: "领券数据"
          },
          {
            name: "报名数",
            tips: "用户在首页和活动页面提交预约报名的数量",
            value: 0,
            key: "signup_num",
            route: "statistics/signup-view",
            routeTitle: "报名数据"
          }
        ],
        // echarts数据
        sellChartData: {
          columns: ["日期", "浏览次数", "浏览人数", "分享次数", "分享人数"],
          rows: [],
        },
        chartColors: ["#5B8FF9", "#5AD8A6", "#FBB937", "#FF3A3A"],
        chartHeight: "110%",
      };
    },
    watch: {
      dateValue(v) {
        if (!v || v.length !== 2) {
          return;
        }
        if (this.isSyncingQuickRange) {
          this.isSyncingQuickRange = false;
          return;
        }
        this.radioValue = "";
        this.timeValue = [...v];
        this.getStatistics(v);
      },
      radioValue(v) {
        if (v) {
          switch (v) {
            case "今日":
              this.timeValue = [formatDate(new Date()), formatDate(new Date())];
              break;
            case "昨日":
              this.timeValue = [
                formatYesterday(new Date()),
                formatYesterday(new Date()),
              ];
              break;
            case "最近7日":
              this.timeValue = [
                getLastSevenDate(new Date()),
                formatDate(new Date()),
              ];
              break;
            case "最近30日":
              this.timeValue = [
                getLastThirtyDate(new Date()),
                formatDate(new Date()),
              ];
              break;
            default:
              break;
          }
          this.isSyncingQuickRange = true;
          this.dateValue = [...this.timeValue];
          this.getStatistics();
        }
      },
    },
    created() {
      this.getStatistics(undefined, 1);
      this.getSellerUrl();
    },
    methods: {
      /**
       * @name:
       * @msg:
       * @param {String} time
       * @param {Boolean} with_lastest 0 不获取最近七日数据 1 获取最近七日数据
       * @return {*} undefined
       */
      getStatistics(time = this.timeValue, with_lastest = 0) {
        console.log(time, 'time');
        let params = { start_date: time[0], end_date: time[1] };
        if (with_lastest) {
          params.with_lastest = with_lastest;
        }
        this.$axios
          .get("/api/v1/statistics/overview", { params })
          .then((res) => {
            if (res.data.status == 200) {
              // 将后端返回的数据映射到 dataObj
              const overview = res.data.data || {};
              this.dataObj.forEach(item => {
                if (overview[item.key] !== undefined) {
                  item.value = overview[item.key] || 0;
                }
              });
            } else {
              this.$popup(res.data.msg, "error");
            }
          });
      },
      getSellerUrl() {
        this.$axios.get("/api/v1/saas/seller/qrcode", {}).then(({ data }) => {
          if (data.status == 200) {
            this.$store.dispatch("setSellerInfo", data.data);
          }
        });
      },
      handleItemClick(item) {
        if (item.route) {
          const routesNeedQuery = [
            "statistics/coupons-pv-view",
            "statistics/product-pv-view",
            "statistics/coupons-view",
            "statistics/signup-view"
          ];
          const payload = {
            addTitle: item.routeTitle || item.name,
            addUrl: item.route
          };
          if (routesNeedQuery.indexOf(item.route) !== -1) {
            const queryParams =
              this.$route && this.$route.query ? { ...this.$route.query } : {};
            if (
              Array.isArray(this.timeValue) &&
              this.timeValue.length === 2 &&
              this.timeValue[0] &&
              this.timeValue[1]
            ) {
              queryParams.start_date = this.timeValue[0];
              queryParams.end_date = this.timeValue[1];
            }
            if (
              Array.isArray(this.dateValue) &&
              this.dateValue.length === 2 &&
              this.dateValue[0] &&
              this.dateValue[1]
            ) {
              queryParams.start_date = this.dateValue[0];
              queryParams.end_date = this.dateValue[1];
            }
            let hasQuery = false;
            for (const key in queryParams) {
              if (
                Object.prototype.hasOwnProperty.call(queryParams, key) &&
                queryParams[key] !== undefined &&
                queryParams[key] !== null &&
                queryParams[key] !== ""
              ) {
                hasQuery = true;
                break;
              }
            }
            if (hasQuery) {
              payload.query = queryParams;
            }
          }
          this.$store.dispatch("addHeadTab", payload);
        }
      },
    },
  };
</script>
<style scoped lang='less'>
  .layout-item {
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
    color: #2b3f57;
    .title {
      font-size: 19px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      text-align: left;
      margin-bottom: 20px;
    }
  }
  .select-item {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #2b3f57;
    /deep/ .el-radio-button__inner {
      width: 113px;
    }
  }
  .data-table {
    flex-wrap: wrap;
  }
  .data-item {
    height: 72px;
    border-right: 1px solid #e1e4ea;
    box-sizing: border-box;
    transition: all 0.3s;
    padding: 0 20px;
    // 默认：6个一行
    flex: 0 0 calc(16.666% - 0.83px);
    min-width: 200px;
    &:nth-child(6n) {
      border-right: none;
    }
    &.csp:hover {
      .data-item__name,
      .data-item__data {
        color: #FF3A3A;
      }
    }
    // 大屏幕：6个一行
    @media (min-width: 1600px) {
      flex: 0 0 calc(16.666% - 0.83px);
      &:nth-child(6n) {
        border-right: none;
      }
    }
    // 中等屏幕：3个一行
    @media (min-width: 1200px) and (max-width: 1599px) {
      flex: 0 0 calc(33.333% - 0.67px);
      &:nth-child(3n) {
        border-right: none;
      }
    }
    // 小屏幕：2个一行
    @media (min-width: 768px) and (max-width: 1199px) {
      flex: 0 0 calc(50% - 0.5px);
      &:nth-child(2n) {
        border-right: none;
      }
    }
    // 超小屏幕：1个一行
    @media (max-width: 767px) {
      flex: 0 0 100%;
      border-right: none;
    }
  }
  .popover-dom {
    width: fit-content;
  }
  .data-item__name-wrapper {
    position: relative;
  }
  .tip-icon {
    width: 16px;
    height: 16px;
    margin-left: 6px;
    flex-shrink: 0;
  }
  .data-item__name {
    font-size: 17px;
    font-family: MicrosoftYaHei;
    color: #747b94;
    transition: color 0.3s;
  }
  .data-item__data {
    font-size: 31px;
    font-family: SFProText-Medium, SFProText;
    font-weight: 500;
    color: #2b3f57;
    transition: color 0.3s;
  }
  .data-chart {
    height: 270px;
  }
  .el-input__inner,
  .el-radio-button__inner {
    border-color: #9ea6bc;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border: 1px solid #ff3b39;
    background: rgba(255, 59, 57, 0.1);
    color: #ff3b39;
    box-shadow: unset;
  }
</style>


// WEBPACK FOOTER //
// src/views/index.vue